<template>

  <div id="app">
        <b-navbar
            fixed-top
            class="navbaro"
            :transparent=true
            :isActive.sync=menuOpen
        >

        <template slot="brand">
            <b-navbar-item
                tag="router-link" :to="{ path: '/' }"
                class="title nav-title"
                :active=false
            >
                SIMON REEVES
            </b-navbar-item>
        </template>

        <template slot="start">
            <!-- 
                
            <b-navbar-item :class="menuOpen ? 'is-size-2 has-text-centered' : ''" tag="router-link" :to="{ name: 'workgallery'}">
                all
            </b-navbar-item>

            <b-navbar-item :class="menuOpen ? 'is-size-2 has-text-centered' : ''" tag="router-link" :to="{ name: 'workgallery', params:{ type : 'personalwork' } }">
                my work
            </b-navbar-item>
            <b-navbar-item :class="menuOpen ? 'is-size-2 has-text-centered' : ''" tag="router-link" :to="{ name: 'workgallery', params:{ type : 'commercialwork' } }">
                work-work
            </b-navbar-item>  -->

            <b-navbar-item :class="menuOpen ? 'is-size-2 has-text-centered' : ''" tag="router-link" :to="{ name: 'about' }">
                about
            </b-navbar-item>
            <b-navbar-item :class="menuOpen ? 'is-size-2 has-text-centered' : ''" tag="router-link" :to="{ name: 'rendertimecalc' }">
                rtc
            </b-navbar-item>
        </template>

        <!-- desktop icons -->
        <template v-if=!menuOpen slot="end">
            <b-navbar-item href="mailto:simon@simonreeves.com">
              <b-icon
                pack="fas"
                icon="envelope"
                size="is-small">
              </b-icon>
            </b-navbar-item>
            <b-navbar-item href="https://instagram.com/simonreeves3d">
              <b-icon
                 pack="fab"
                  icon="instagram"
                  size="is-small">
              </b-icon>
            </b-navbar-item>
            <b-navbar-item href="https://vimeo.com/simonreeves">
                <b-icon
                    pack="fab"
                    icon="vimeo"
                    size="is-small">
                </b-icon>
            </b-navbar-item>
            <b-navbar-item href="https://behance.net/simonreeves3d">
                <b-icon
                    pack="fab"
                    icon="behance"
                    size="is-small">
                </b-icon>
            </b-navbar-item>
            <b-navbar-item href="https://github.com/simonreeves">
              <b-icon
                    pack="fab"
                  icon="github"
                  size="is-small">
              </b-icon>
            </b-navbar-item>
            <b-navbar-item href="https://twitter.com/simonreeves3d">
                <b-icon
                    pack="fab"
                    icon="twitter"
                    size="is-small">
                </b-icon>
            </b-navbar-item>
            <b-navbar-item href="https://www.linkedin.com/in/simonreeves/">
                <b-icon
                    pack="fab"
                    icon="linkedin"
                    size="is-small">
                </b-icon>
            </b-navbar-item>
        </template>

        <!-- mobile icons -->

        <template slot="end" v-if=menuOpen>

            <b-navbar-item class="has-text-centered">
                <b-button class="mobile-social-icons" tag="a" href="mailto:simon@simonreeves.com" icon-pack="fas" icon-right="envelope" size="is-large"></b-button>
                <b-button class="mobile-social-icons" tag="a" href="https://instagram.com/simonreeves3d" icon-pack="fab" icon-right="instagram" size="is-large"></b-button>
                <b-button class="mobile-social-icons" tag="a" href="https://vimeo.com/simonreeves" icon-pack="fab" icon-right="vimeo" size="is-large"></b-button>
                <b-button class="mobile-social-icons" tag="a" href="https://behance.net/simonreeves3d" icon-pack="fab" icon-right="behance" size="is-large"></b-button>
            </b-navbar-item>
            <b-navbar-item class="has-text-centered">
                <b-button class="mobile-social-icons" tag="a" href="https://github.com/simonreeves" icon-pack="fab" icon-right="github" size="is-large"></b-button>
                <b-button class="mobile-social-icons" tag="a" href="https://twitter.com/simonreeves3d" icon-pack="fab" icon-right="twitter" size="is-large"></b-button>
                <b-button class="mobile-social-icons" tag="a" href="https://www.linkedin.com/in/simonreeves" icon-pack="fab" icon-right="linkedin" size="is-large"></b-button>
            </b-navbar-item>

        </template>

    </b-navbar>
    
    <transition name="fade" mode="out-in">
        <router-view/>
    </transition>

  </div>
</template>

<script>

    export default {
        data() {
            return {
                menuOpen: false
            }
        }
    }
</script>

<style lang="scss">

    // for mobile import
    @import '~bulma/sass/utilities/_all';

    .fade-enter-active, .fade-leave-active {
        transition: all .15s ease;
    }

    .title {
        font-size: 3rem;
    }
    // surprised I have to add this
    .navbar-end {
        margin-right: 1rem;
    }

    .mobile-social-icons {
        border: 0;
        padding: 0 1.5em;
    }

    @include mobile {
        .title {
            font-size: 2.2rem;
        }
    }

</style>
